
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSApprovalGrid extends Serenity.EntityGrid<POSApprovalRow, any> {
        protected getColumnsKey() { return 'Retail.POSApproval'; }
        protected getDialogType() { return POSApprovalDialog; }
        protected getIdProperty() { return POSApprovalRow.idProperty; }
        protected getInsertPermission() { return POSApprovalRow.insertPermission; }
        protected getLocalTextPrefix() { return POSApprovalRow.localTextPrefix; }
        protected getService() { return POSApprovalService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);  
            this.slickGrid.setOptions({ rowHeight: 30 });
        }

        protected addButtonClick() {
            
            let now = new Date();

            var voucherNo = FormatHelper.GetVoucherNo(92);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[92].AutoPosting;
            this.editItem(<POSApprovalRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                TransDate: now.toDateString(),
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                EmployeeId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 92,
                UserId: userDefinition.UserId,
                AutoPosting: autoposting
                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        //protected getQuickFilters() {
        //    var filters = super.getQuickFilters();

        //    filters.push({
        //        type: Serenity.LookupEditor,
        //        options: {
        //            lookupKey: POSApprovalRow.lookupKey
        //        },
        //        field: 'TransId',
        //        title: 'Contains Transaction in Details',
        //        handler: w => {
        //            (this.view.params as TransactionListRequest).TransId = Q.toId(w.value);
        //        },
        //        cssClass: 'hidden-xs'
        //    });

        //    return filters;
        //}
    }
}